import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import {goBack} from "../../fn/navigation";
import AppointmentDetails from "../../components/Appointments/AppointmentDetails";
import {faFileSignature} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {withStyles} from "@material-ui/core/styles";
import DeleteButton from "../../components/Form/DeleteButton";
import ArchiveButton from "../../components/Form/ArchiveButton";

const icn = (iconType, classes) => {
    return <FontAwesomeIcon icon={iconType} className={classes.tabBarButtonIcon}/>;
}

const AppointmentsShow = ({appointment, structure, protocols, notes, backLink, role, classes}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('appointments.appointment')}
            items={[
                {
                    icon: 'arrow_back',
                    text: i18n.get('default.nav.back'),
                    href: appointment.isArchived ? `/archive/customer/${appointment.customer.id}` : `/customers/${appointment.customer.id}`,
                    onClick: (event) => {
                        event.preventDefault();
                        goBack(appointment.isArchived ? `/archive/customer/${appointment.customer.id}` : `/customers/${appointment.customer.id}`);
                    },
                    color: 'secondary',
                },
                {
                    fontawesome: icn(faFileSignature, classes),
                    text: i18n.get('appointments.new_protocol'),
                    href: `/protocols/create/customer/${appointment.customer.id}/appointment/${appointment.id}/structure/${structure.id}`,
                    hidden: appointment.isArchived
                },
                {
                    icon: 'edit',
                    text: i18n.get('appointments.edit'),
                    href: `/appointments/${appointment.id}/edit`,
                    hidden: appointment.isArchived
                }
            ]}
        >
            {!appointment.isArchived &&
            <React.Fragment>
                {role === 'admin' &&
                <DeleteButton
                    text={i18n.get('appointments.delete_appointment')}
                    href={`/appointments/${appointment.id}`}
                    confirmMessage={i18n.get('appointments.delete_confirm_message')}
                    successMessage={i18n.get('appointments.delete_success_message')}
                    handleSuccess={() => {
                        window.location.href = `/customers/${appointment.customer.id}`
                    }}
                />
                }

                {role !== 'technician' &&
                <ArchiveButton
                    text={i18n.get('appointments.archive_appointment')}
                    href={`/appointments/${appointment.id}/archive`}
                    confirmMessage={i18n.get('appointments.archive_confirm_message')}
                    successMessage={i18n.get('appointments.archive_success_message')}
                    handleSuccess={() => {
                        window.location.href = `/customers/${appointment.customer.id}`
                    }}
                />
                }
            </React.Fragment>
            }
        </Toolbar>

                <AppointmentDetails appointment={appointment} protocols={protocols} notes={notes} />
    </Layout>
);

const styles = theme => ({
    tabBar: {
        marginBottom: theme.spacing.unit * 3,
    },
    tabBarTitle: {
        flexGrow: 1,
    },
    tabBarButton: {
        marginLeft: theme.spacing.unit * 2,
    },
    tabBarButtonIcon: {
        marginRight: theme.spacing.unit,
    },
});

export default withStyles(styles)(AppointmentsShow);



// WEBPACK FOOTER //
// ./resources/assets/js/pages/appointments/Show.jsx